/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { alpha, Theme } from "@mui/material";

export const alertLegalbirdStyle = {
  hint: (theme: Theme) => ({
    color: theme.palette.text.primary,
  }),
  hintSuccess: (theme: Theme) => ({
    backgroundColor: alpha(theme.palette.success.light, 0.3),
    "& strong": {
      color: theme.palette.success.main,
    },
  }),
  hintWarning: (theme: Theme) => ({
    backgroundColor: alpha(theme.palette.warning.light, 0.3),
    "& strong": {
      color: theme.palette.warning.main,
    },
  }),
  hintError: (theme: Theme) => ({
    backgroundColor: alpha(theme.palette.error.light, 0.3),
    "& strong": {
      color: theme.palette.error.main,
    },
  }),
};
